export enum LockoutPageVariant {
    READ,
    CREATE,
    CLONE,
}
